export default "__VITE_ASSET__6b67395b__"